import { q } from "groqd";

/**
 * Get a list of published articles
 */
export const articleFilter = `_type == "article" && hidden != true`;

export const baseArticleQuery = q("*").filterByType("article").filter("hidden != true");

export const projectFilter = `_type == "project" && draft != true`;

// Projections eg. _id, _type, title, slug, etc.
// Preset fields

export const excerptQuery = (field = "body") =>
    `array::join(string::split((pt::text(${field})), "")[0..$length], "") + "..."`;

export const pathQuery = (basePath = "/") => `"${basePath}" + slug.current`;

// Fields eg. `title, slug, body, etc.`
/** Create excerpt from portable text `body` field */
export const excerptField = (length = 255) =>
    `"excerpt": array::join(string::split((pt::text(body)), "")[0..${length}], "") + "..."`;

/** Create path for `slug.current` field  */
export const pathField = (basePath = "/") => `"path": "${basePath}" + slug.current`;

// Sorting eg : `| order(publishedAt desc)`
/** Sort articles by `publishedAt` descending */
export const articleSort = `order(publishedAt desc)`;

export const projectSort = `order(startDate desc)`;

// Slices eg : [0..1] or [0..]
/** Get n items */
export const limitedSlice = (limit = 5) => `[0...${limit}]`;
